@if (rating()) {
  @if (isCustomerRating()) {
    <app-customer-rating [product]="product()"/>
  } @else {
    <app-product-rating-points [showEmptyStars]="false" [rating]="rating()"/>
  }
  <span [class.bold-text]="isCustomerRating()">
    {{ rating().name }}
  </span>
}
